import React, { useState, useEffect } from "react";
import { io } from "socket.io-client";
import "./CommunityPage.css"; // Main CSS for remaining styles
import CommunityHeader from "../../components/Community/CommunityHeader"; // Header component
import CommunityProfileDescription from "../../components/Community/Communityprofiledescription"; // Profile Description component
import CommunityTabsRoom from "../../components/Community/Communitytabsroom"; // Tabs and Toggles component
import CommunityChatRoom from "../../components/Community/CommunityChatRoom"; // Chat Room component
import CommunityMessageInput from "../../components/Community/CommunityMessageInput"; // Message Input component
import CommunityLiveCommentSection from "../../components/Community/CommunityLiveCommentSection"; // Live Comment Section component
import CommunityLayout from "../../components/Community/CommunityLayout"; // Import CommunityLayout


// Initialize socket.io
const socket = io("http://localhost:5000");

const CommunityPage = () => {
  const [messages, setMessages] = useState([
    { user: "john", text: "did not watch yet, planning to do so" },
    { user: "dona", text: "you should start watching one piece" },
  ]);
  const [typing, setTyping] = useState("member dona typing...");
  const [messageInput, setMessageInput] = useState("");
  const [liveSectionVisible, setLiveSectionVisible] = useState(true);
  const [liveComments, setLiveComments] = useState([
    { text: "hey guys how are you", dotColor: "brown" },
    { text: "john what anime you been watching lately", dotColor: "gray" },
    { text: "hahahahaahahahahaha-", dotColor: "red" },
  ]);

  useEffect(() => {
    socket.on("message", (msg) => {
      setMessages((prev) => [...prev, msg]);
    });

    socket.on("typing", (user) => {
      setTyping(`${user} is typing...`);
      setTimeout(() => setTyping(""), 3000);
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const handleSendMessage = () => {
    if (messageInput.trim()) {
      socket.emit("send_message", { user: "You", text: messageInput });
      setMessages((prev) => [...prev, { user: "You", text: messageInput }]);
      setMessageInput("");
    }
  };

  return (
    <div className="CommunityPage-container">
      <div className="CommunityPage">
        {/* Top Section */}
        <CommunityHeader
          roomTitle="JOHN HOSTING"
          roomName="ROOM NAME: BEBOOS"
        />

        {/* Profile Details Section */}
        <CommunityProfileDescription
          userName="JOHN HOSTING"
          description="Welcome to my room, consectetur adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullam."
          avatarSrc="john-prof-pic-07.png"
        />

        {/* Tabs and Toggles Section */}
        <CommunityTabsRoom />

        {/* Member Chat Section */}
        <CommunityChatRoom messages={messages} typing={typing} />
        <CommunityMessageInput
          messageInput={messageInput}
          setMessageInput={setMessageInput}
          handleSendMessage={handleSendMessage}
        />

        {/* Live Comment Section */}
        {liveSectionVisible && (
          <CommunityLiveCommentSection
            liveComments={liveComments}
            setLiveSectionVisible={setLiveSectionVisible}
          />
        )}

        {/* Footer Section */}
        <footer className="CommunityPage-footer">
          <button
            className="CommunityPage-footerButton"
            onClick={() => setLiveSectionVisible(true)}
          >
            Live comment section
          </button>
          <button className="CommunityPage-footerButton">only me section</button>
          <button className="CommunityPage-footerButton">Member section</button>
        </footer>
      </div>
    </div>
  );
};

export default CommunityPage;
